import React, { useRef, useEffect, useState } from 'react';
import MapComponent from '../Components/ControlRoom/MapComponent';
import ConfirmModal from '../Components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card } from 'primereact/card';
import { classNames } from "primereact/utils";
import WhereSystem from '../WhereSystem';
import WhereEventNames from '../EventSystem/WhereEventNames';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import '../styles/mainpage.css';
import WhereDictionary from '../Utills/WhereDictionary';
import AssignedTrucksForOrderComponent from '../Components/AssignedTrucksForOrderComponent';

export default function MainPage() {
  const { logout } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);
  const [factories, setFactories] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [ordersCount, setOrdersCount] = useState({ total: 0, pending: 0, completed: 0, inTransit: 0 });
  const [activePanel, setActivePanel] = useState('factories');
  const [ordersData, setOrdersData] = useState([]);
  const [mapContainerSize, setMapContainerSize] = useState({ height: "200px", width: "300px" })
  const [selectedFactoryId, setSelectedFactoryId] = useState(null);
  const [selectedTruckId, setSelectedTruckId] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const mapContainerRef = useRef(null);
  const navigate = useNavigate();

  const factoryMarkerIcon = {
    url: '/images/factory-icon.png',
  };

  const truckMarkerIcon = {
    url: '/images/truck-icon.png',
  };

  const customerSiteMarkerIcon = {
    url: '/images/site-icon.png',
  };
  const handleCancel = () => setShowConfirm(false);
  const handleConfirm = () => {
    setShowConfirm(false);
    logout();
    navigate('/login', { replace: true });
  };

  const loadOrders = async () => {
    try {
      WhereSystem.services.orderService.getAdminOrders((res) => {
        console.log('admin orders', res);
        const isOk = res?.IsSuccess === true || res?.isSuccess === true || Array.isArray(res);
        if (isOk) {
          let data = Array.isArray(res)
            ? res
            : (res?.ResultObject || res?.result || res?.data || []);


          const ordersCol = new WhereDictionary();
          data.forEach((order) => {
            ordersCol.add(order.orderId, order);
          })

          data = ordersCol.getValuesAsArray();
          setOrdersData(data);
          const total = data.length || 0;
          const pending = data.filter(o => (o.orderStatus || '').toLowerCase() === 'pending').length;
          const completed = data.filter(o => (o.orderStatus || '').toLowerCase() === 'completed').length;
          const inTransit = data.filter(o => (o.orderStatus || '').toLowerCase() === 'assigned' || (o.status || '').toLowerCase() === 'assigned').length;

          setOrdersCount({ total, pending, completed, inTransit });
        } else {
          console.log('Failed to load admin orders', res?.message || res);
        }
      })

    } catch (e) {
      console.error('Error loading orders:', e);
    }
  };

  const loadFactories = async () => {
    try {
      WhereSystem.services.adminService.getFactories((res) => {
        console.log('factories', res);
        const isOk = res?.IsSuccess === true || res?.isSuccess === true || Array.isArray(res);
        if (isOk) {
          const data = Array.isArray(res) ? res : (res?.ResultObject || res?.result || res?.data || []);
          setFactories(data);
        } else {
          console.log('Failed to load factories', res?.message || res);
        }
      })

    } catch (e) {
      console.error('Error loading factories:', e);
    }
  };

  const loadTrucks = async () => {
    try {
      WhereSystem.services.adminService.getTrucks((res) => {
        console.log('trucks', res);
        const isOk = res?.IsSuccess === true || res?.isSuccess === true || Array.isArray(res);
        if (isOk) {
          const data = Array.isArray(res) ? res : (res?.ResultObject || res?.result || res?.data || []);
          setTrucks(data);
        } else {
          console.log('Failed to load trucks', res?.message || res);
        }
      })

    } catch (e) {
      console.error('Error loading trucks:', e);
    }
  };

  useEffect(() => {
    loadFactories();
    loadOrders();
    loadTrucks();
    setMapContainerSize({ height: `${mapContainerRef.current.offsetHeight - 10}px`, width: `${mapContainerRef.current.offsetWidth}px` });
  }, []
  )


  const summary = [
    { label: 'Factories', value: factories.length, icon: 'pi pi-building' },
    { label: 'Total Trucks', value: trucks.length, icon: 'pi pi-truck' },
    { label: 'Orders', value: ordersCount.total, icon: 'pi pi-shopping-bag' },
    { label: 'In Transit', value: ordersCount.inTransit, icon: 'pi pi-send' },
    { label: 'Pending Orders', value: ordersCount.pending, icon: 'pi pi-clock' },
    { label: 'Completed Orders', value: ordersCount.completed, icon: 'pi pi-check-circle' }
  ];


  const handleStatusChange = (factory, newStatus) => {
    console.log("change factory status:", factory.id);
    console.log("change factory status:", newStatus);
    if (newStatus === "offline") {
      WhereSystem.services.userService.updateFactoryStatusToOffline({ station_id: factory.id }, (res) => {
        console.log("update factory status response:", res);
        loadFactories();
      })
    }
    if (newStatus === "online") {
      WhereSystem.services.userService.updateFactoryStatusToOnline({ station_id: factory.id }, (res) => {
        console.log("update factory status response:", res);
        loadFactories();
      })
    }
  };

  const showFactoryOnMap = (factory, icon) => {
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, { markers: [{ position: { lat: factory.location[0], lng: factory.location[1] }, title: factory.stationName, icon: icon }], clearOld: true })
  }

  const showOrderOnMap = (order) => {
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, { markers: [{ position: { lat: order.deliveryLocation[0], lng: order.deliveryLocation[1] }, title: order.customerName, icon: customerSiteMarkerIcon }, { position: { lat: order.pickupLocation[0], lng: order.pickupLocation[1] }, title: order.factoryName, icon: factoryMarkerIcon }], clearOld: true });
    const routeData = {
      routingPoints: { origin: order.pickupLocation, destination: order.deliveryLocation }, afterResp: (routeResp) => {
        console.log(routeResp);
        console.log(`Distance:${routeResp.routes[0].legs[0].distance.text} Time:${routeResp.routes[0].legs[0].duration.text} }`)
      }
    }
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.DO_ROUTING, [routeData])

  }

  const showTruckOnMap = (truck, icon) => {
    const loc = truck.location || truck.currentLocation || truck.lastKnownLocation;
    if (Array.isArray(loc) && loc.length >= 2) {
      WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, {
        markers: [{ position: { lat: loc[0], lng: loc[1] }, title: truck.truckNumber || truck.truck_number || 'Truck', icon }],
        clearOld: true
      });
    }
  }

  const showAllFactoriesOnMap = (factories, icon) => {
    console.log("show all factories", factories);
    const factoryMarkers = [];
    factories.forEach(factory => {
      factoryMarkers.push({ position: { lat: factory.location[0], lng: factory.location[1] }, title: factory.stationName, icon: icon });
    })
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, { markers: factoryMarkers, clearOld: true })
  };

  const showAllTrucksOnMap = (trucks, icon) => {
    console.log("show all trucks", trucks);
    const truckMarkers = [];
    trucks.forEach((t) => {
      const loc = t.location || t.currentLocation || t.lastKnownLocation;
      if (Array.isArray(loc) && loc.length >= 2) {
        truckMarkers.push({
          position: { lat: loc[0], lng: loc[1] },
          title: t.truckNumber || t.truck_number || 'Truck',
          icon: icon
        });
      }
    });
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, { markers: truckMarkers, clearOld: true });
  };

  const showAllOrdersOnMap =(orders)=>{ 

    const orderMarkers = [];
    orders.forEach(order => {
      orderMarkers.push({ position: { lat: order.deliveryLocation[0], lng: order.deliveryLocation[1] }, title: order.customerName, icon: customerSiteMarkerIcon });
      orderMarkers.push({ position: { lat: order.pickupLocation[0], lng: order.pickupLocation[1] }, title: order.factoryName, icon: factoryMarkerIcon });
    }
  )
    WhereSystem.EventSystem.raiseEvent(WhereEventNames.ADD_MARKERS, { markers: orderMarkers, clearOld: true });
    // const routeData = {
    //   routingPoints: { origin: order.pickupLocation, destination: order.deliveryLocation }, afterResp: (routeResp) => {
    //     console.log(routeResp);
    //     console.log(`Distance:${routeResp.routes[0].legs[0].distance.text} Time:${routeResp.routes[0].legs[0].duration.text} }`)
    //   }
    // }
    // WhereSystem.EventSystem.raiseEvent(WhereEventNames.DO_ROUTING, routeData)
  }

  return (
    <div className="cyber-page" style={{ display: 'flex', flexDirection: 'column' }}>
      <main style={{ padding: '20px' }}>

        <div className="kpi-grid" style={{ marginBottom: 10, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
          {summary.map((kpi) => {
            const targetPanel =
              kpi.label === 'Total Trucks' ? 'trucks' :
                kpi.label === 'Orders' ? 'orders' :
                  kpi.label === 'Completed Orders' ? 'orders_completed' :
                    kpi.label === 'Pending Orders' ? 'orders_pending' :
                      kpi.label === 'In Transit' ? 'orders_in_transit' :
                        'factories';
            const isActive = activePanel === targetPanel;
            return (
              <Card key={kpi.label} className={classNames('kpi-card p-card-shadow', { 'kpi-card--active': isActive })} style={{ cursor: 'pointer' }} onClick={() => setActivePanel(targetPanel)}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: "20px" }}>
                  <div>
                    <div style={{ fontSize: 12 }}>{kpi.label}</div>
                    <i className={classNames(kpi.icon)} style={{ fontSize: 24 }}></i>
                  </div>
                  <div>
                    <div style={{ fontSize: 20, fontWeight: 700 }}>{kpi.value}</div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16, marginBottom: 20, height: "68vh" }}>
          <Card title={activePanel === 'factories' ? 'Factories' : activePanel === 'trucks' ? 'Trucks' : 'Orders'} className="cyber-card" style={{ height: "100%", overflowY: "auto", scrollbarWidth: "none", msOverflowStyle: "none", }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ display: "flex", justifyContent: "end", marginTop: "-30px" }}>
                {activePanel === 'factories' && (
                  <button className="btn-status btn-show-all" onClick={() => showAllFactoriesOnMap(factories, factoryMarkerIcon)} style={{ zIndex: "9999", width: "140px" }}>Show All Factories</button>
                )}
                {activePanel === 'trucks' && (
                  <button className="btn-status btn-show-all" onClick={() => showAllTrucksOnMap(trucks, truckMarkerIcon)} style={{ zIndex: "9999", width: "140px" }}>Show All Trucks</button>
                )}
                {activePanel === 'orders' || activePanel === 'orders_pending' || activePanel === 'orders_in_transit' || activePanel === 'orders_completed' ? (
                  <button className="btn-status btn-show-all" onClick={() => {
                    const s = activePanel;
                    const filtered = ordersData.filter(o => {
                      const st = (o.orderStatus || '').toLowerCase();
                      if (s === 'orders_pending') return st === 'pending';
                      if (s === 'orders_in_transit') return st === 'assigned';
                      if (s === 'orders_completed') return st === 'completed';
                      return true;
                    });
                    showAllOrdersOnMap(filtered);
                  }} style={{ zIndex: "9999", width: "140px" }}>Show All Orders</button>
                ) : null}
              </div>
              {activePanel === 'factories' && factories.map((b) => {
                const isSelected = selectedFactoryId === b.id || selectedFactoryId === b.stationId;
                return (
                  <div key={b.stationName} className={classNames('branch-item', { 'branch-item--active': isSelected })} style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "5px", borderRadius: 10, zIndex: 11000 }} onClick={() => { setSelectedFactoryId(b.id ?? b.stationId); showFactoryOnMap(b, factoryMarkerIcon); }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <p><i className="pi pi-building"></i> {b.stationName}</p>
                      <p style={{
                        backgroundColor: "transparent", color: b.operatingStatus === "operational" ? "#0a800a" : "#a30000", padding: "2px 8px",
                        border: b.operatingStatus === "operational" ? "1px solid #d4fcd4" : "1px solid #ffd6d6",
                        borderRadius: "12px", fontSize: "12px", fontWeight: "600", display: "inline-block", minWidth: "60px", textAlign: "center",
                      }}> {b.operatingStatus}</p>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <p>{b.address}</p>
                      <div>
                        {b.operatingStatus === "offline" ? (
                          <button onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFactoryId(b.id ?? b.stationId);
                            confirmDialog({
                              message: 'Are you sure you want to set this factory Online?',
                              header: 'Confirmation',
                              icon: 'pi pi-exclamation-triangle',
                              acceptClassName: 'p-button-danger',
                              acceptLabel: 'Yes',
                              rejectLabel: 'No',
                              accept: () => handleStatusChange(b, "online"),
                              reject: () => console.log("Cancelled"),
                            });
                          }} className="btn-status btn-online"> Go Online</button>
                        ) : (
                          <button onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFactoryId(b.id ?? b.stationId);
                            confirmDialog({
                              message: 'Are you sure you want to set this factory offline? If any Orders Assigned to this factory assign Another Nearest factory',
                              header: 'Confirmation',
                              icon: 'pi pi-exclamation-triangle',
                              acceptClassName: 'p-button-danger',
                              acceptLabel: 'Yes',
                              rejectLabel: 'No',
                              accept: () => handleStatusChange(b, "offline"),
                              reject: () => console.log("Cancelled"),
                            });
                          }} className="btn-status btn-offline">  Go Offline</button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}

              {activePanel === 'trucks' && trucks.map((t) => {
                const isSelected = selectedTruckId === t.id;
                return (
                  <div key={t.id} className={classNames('branch-item', { 'branch-item--active': isSelected })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', borderRadius: 10, zIndex: 11000 }} onClick={() => { setSelectedTruckId(t.id); showTruckOnMap(t, truckMarkerIcon); }}>
                    <div style={{ fontWeight: 200 }}>
                      <p>{t.truckNumber}</p>
                      <p>{t.driverMobileNumber}</p>
                      {t.factory && <p>{t.factory}</p>}
                    </div>
                    <div style={{ fontWeight: 200 }}>
                      <p style={{ backgroundColor: 'transparent', color: '#00e5ff', padding: '2px 8px', border: '1px solid #00e5ff', borderRadius: '12px', fontSize: '12px', fontWeight: '600', display: 'inline-block', minWidth: '60px', textAlign: 'center' }}>
                        {t.currentStatus}
                      </p>
                      <p>{t.driverName}</p>
                    </div>
                  </div>
                );
              })}

              {(activePanel === 'orders' || activePanel === 'orders_pending' || activePanel === 'orders_in_transit' || activePanel === 'orders_completed') && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {(() => {
                    // filter orders by activePanel
                    const filteredOrders = ordersData.filter(o => {
                      const s = (o.orderStatus || '').toLowerCase();
                      if (activePanel === 'orders_pending') return s === 'pending';
                      if (activePanel === 'orders_in_transit') return s === 'assigned';
                      if (activePanel === 'orders_completed') return s === 'completed';
                      return true; // for total orders
                    });

                    // if no orders found → show message
                    if (filteredOrders.length === 0) {
                      let msg = "No Orders";
                      if (activePanel === "orders_pending") msg = "No Pending Orders";
                      if (activePanel === "orders_in_transit") msg = "No In-Transit Orders";
                      if (activePanel === "orders_completed") msg = "No Completed Orders";
                      if (activePanel === "orders") msg = "No Orders Available";

                      return (
                        <div style={{ padding: 10, textAlign: "center", backgroundColor: "#3c3c3c", color: "white" }}>
                          {msg}
                        </div>
                      );
                    }
                    // else → show orders
                    return filteredOrders.map((o) => (
                      <div key={o.orderId} className={classNames('branch-item', { 'branch-item--active': selectedOrderId === o.orderId })} onClick={() => { setSelectedOrderId(o.orderId); showOrderOnMap(o); }} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 10, borderRadius: 10, zIndex: 12000 }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <strong>{o.orderNo}</strong>
                          <span style={{ opacity: 0.8 }}>{o.customerName}</span>
                          <span style={{ opacity: 0.6, fontSize: 12 }}>{o.deliveryLocationName}</span>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <p style={{ backgroundColor: "transparent", color: "#00e5ff", padding: "2px 8px", border: "1px solid #00e5ff", borderRadius: "12px", fontSize: "12px", fontWeight: "600", display: "inline-block", minWidth: "60px", textAlign: "center" }}>
                            {o.orderStatus}
                          </p>
                          {o.factoryName &&
                            <>
                              <div style={{ opacity: 0.7, fontSize: 12 }}>
                                <i className="pi pi-building"></i> {o.factoryName}
                              </div>
                            </>
                          }
                        </div>
                      </div>
                    ));
                  })()}
                </div>
              )}
            </div>
          </Card>
          <div title="Live Tracking" className="cyber-card" ref={mapContainerRef} style={{ height: "100%", }}>
            <div style={{ position: 'relative' }}>
              <MapComponent style={{ height: mapContainerSize.height, width: mapContainerSize.width, zIndex: 1 }} />
            </div>
          </div>
          {/* <MapComponent style={{ height: mapContainerSize.height, width: mapContainerSize.width, zIndex: 1 }} className="mt-5"/> */}

        </div>
      </main>

      <ConfirmModal show={showConfirm} title="Logout" message="Are you sure you want to logout?" confirmText="Logout" cancelText="Cancel" onConfirm={handleConfirm} onCancel={handleCancel} style={{ zIndex: 2000 }} />

      <div style={{ zIndex: "40000" }}>
        <ConfirmDialog appendTo={document.body} />
      </div>
    </div>
  );
}


// const statusTag = (row) => (
//   <Tag value={row.status} severity={row.status === 'Online' ? 'success' : 'danger'} />
// );

// const rowExpansionTemplate = (data) => (
//   <div style={{ padding: 16 }}>

//   </div>
// );



{/* Orders summary + Trucks overview */ }
{/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16 }}>
          <Card title="Orders Summary" className="cyber-card">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <Card className="kpi-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/orders')}>
                <div className='d-flex justify-content-between'>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>Total Orders</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>4</div>
                </div>
              </Card>

              <Card className="kpi-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/orders?status=pending')}>
                <div className='d-flex justify-content-between'>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>Pending</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>1</div>
                </div>
              </Card>

              <Card className="kpi-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/orders?status=completed')}>
                <div className='d-flex justify-content-between'>
                  <div style={{ fontSize: 14, fontWeight: 500 }}>Completed</div>
                  <div style={{ fontSize: 20, fontWeight: 700 }}>3</div>
                </div>
              </Card>
            </div>
          </Card>
          <Card title="Trucks Overview" className="cyber-card">
            <div className="cyber-table">
              <DataTable value={trucks} paginator rows={5} rowExpansionTemplate={rowExpansionTemplate} dataKey="id">
                <Column expander style={{ width: '3rem' }} />
                <Column field="id" header="Truck" body={(row) => <strong style={{ color: '#00e5ff' }}>{row.id}</strong>} />
                <Column field="factory" header="Factory" />
                <Column field="driver" header="Driver" />
                <Column header="Status" body={statusTag} />
              </DataTable>
            </div>
          </Card>
        </div> */}